<style lang="less" scoped>
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
                    <div class="flex detail-form-parent-div">
                        <div class="flex-1">
                            <el-form-item label="运营商名称" prop="serviceToName">
                                <el-input v-model="detailForm.serviceToName" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="服务对象" prop="serviceToTypeName">
                                <el-select class="full-width" v-model="detailForm.serviceToTypeName" size="small" clearable>
                                    <el-option v-for="(item,index) in serviceType" :label="item.configName" :value="item.configVal" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="背景信息" prop="backInfo">
                                <el-input v-model="detailForm.backInfo" size="small" type="textarea" :rows="5"></el-input>
                            </el-form-item>
                            <el-form-item label="服务记录" prop="serviceRecord">
                                <el-input v-model="detailForm.serviceRecord" size="small" type="textarea" :rows="5">></el-input>
                            </el-form-item>
                        </div>
                        <div class="flex-1"></div>
                    </div>
                </el-form>
            </div>
            <div class="detail-content-footer-div">
                <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:false, //是否编辑模式
                pageTitle:'服务记录新增',
                // 默认值设置
                detailForm: {}, //表单内容
                serviceType:[], //服务对象
            }
        },
        methods: {
            //初始化是否为编辑模式
            init() {
                if(this.$store.state.editId){
                    this.editFlag = true;
                    this.pageTitle = "服务记录编辑";
                    this.getFormInfo();
                }
                this.getConfig();
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$S.getFormInfo(_,_.$A.feedback.serviceFeedback +'/'+_.$store.state.editId,function(res){
                     _.detailForm = res.data.data;
                });
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                _.detailForm.corpNo = _.$store.state.corpNo;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$S.submitForm(_, _.$A.feedback.serviceFeedback, _.editFlag, _.detailForm, pageConfig.listRouter);
                    }
                });
            },
            //获取服务对象下拉框
            getConfig(){
                let _ = this;
                _.$H.post(_,_.$A.config.list,{configType:"190"}).then(res => {
                    _.serviceType = res.data.data;
                })
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>